const translationGe = {
    home: "მთავარი",
    about_us: "ჩვენს შესახებ",
    services: "სერვისები",
    air_freight: "საჰაერო",
    land_freight: "სახმელეთო",
    sea_freight: "საზღვაო",
    prices: "ფასები",
    contact: "კონტაქტი",
    log_in: "ავტორიზაცია",
    sign_up: "რეგისტრაცია",
    welcome: "მოგესალმებით",
    password_email_incorrect: "პაროლი ან ელ-ფოსტა არასწორია!",
    transportation_in_any_direction: "ტრანსპორტირება ნებისმიერი მიმართულებით",
    logistics_is_simple_with_us: "ჩვენთან ლოგისტიკა მარტივია",
    email_address: "ელ. ფოსტა",
    password: "პაროლი",
    forgot_password: "დაგავიწყდათ პაროლი ?",
    recover_here: "აღდგენა",
    enter: "შესვლა",
    register: "რეგისტრაცია",
    not_register_yet: "არ ხარ დარეგისტრირებული ?",
    successfully: "მოქმედება დასრულდა წარმატებთ",
    passwords_dont_match: "პაროლები არ ემთხვევა !",
    fill_all_fields: "შეავსეთ ყველა ველი !",
    agree_terms: "რეგისტრაციისთვის დაეთანხმეთ წესებს და პირობებს !",
    email_or_already_registerd:
        "შეამოწმეთ ელ-ფოსტის ვალიდურობა ან მომხმარებელი უკვე დარეგისტრირებულია",
    physical_person: "ფიზიკური პირი",
    legal_entity: "იურიდიული პირი",
    name: "სახელი",
    name_eng: "სახელი ინგლისურად",
    personal_id: "პირადი ნომერი",
    company_id: "კომპანიის ID",
    repeat_password: "გაიმეორეთ პაროლი",
    surname: "გვარი",
    surname_eng: "გვარი ინგლისურად",
    company_name: "კომპანის სახელი",
    company_name_eng: "კომპანიის სახელი ინგლისურად",
    phone: "ტელეფონი",
    password_eight_character: "(8 ან მეტი სიმბოლოსგან)",
    agree_to_our: "დაეთანხმეთ ჩვენს",
    terms_of_use: "პირობებსა",
    and: "და",
    privacy_policy: "კონფიდენციალურობის პოლიტიკას",
    already_have_an_account: "უკვე გაქვთ ანგარიში",
    send: "გაგზავნა",
    got_questions_or_need_more_information:
        "გაქვთ კითხვები ? გჭირდებათ მეტი ინფორმაცია ?",
    fill_in_your_information_and_we_will_get_back_to_you:
        "შეავსეთ ფორმა და დაელოდეთ ჩვენს ზარს",
    error_msg: "დაფიქსირდა შეცდომა!",
    footer_text: `MGL Parcel  ახალი  საამანათო მიმათულებაა MGL Group- ის, რომელიც წარმოადგენს ბულგარულ- ქართულ კომპანიას და 2012 წლიდან ოპერირებს ქართულ ბაზარზე.
    ჩვენ გთავაზობთ ამანათების ტრანსპორტირებას ჩინეთიდან, აშშ-იდან და საბერძნეთიდან.`,
    frequently_asked_questions: "ხშირად დასმული კითხვები",
    balance: "ბალანსი",
    my_balance: "ჩემი ბალანსი",
    balance_top_up: "ბალანსის შევსება",
    bonus_points: "ბონუს ქულები",
    parcels: "ამანათები",
    my_parcels: "ჩემი ამანათები",
    courier_service: "საკურიერო სერვისი",
    courier: "საკურიერო",
    addresses: "მისამართები",
    my_addresses: "ჩემი მისამართები",
    pick_country_for_address: "აირჩიე ქვეყანა, რომ ნახო შესაბამისი მისამართი",
    back_to_countries: "უკან",
    no_office_in_country: "ამ ქვეყანაში საწყობი ჯერ არ არის",
    home_delivery_prices: "სახლში მიტანის ტარიფი",
    prices_in_gel: "ფასები ლარში (₾)",
    included_up_to_kg: "10 კგ-მდე მიტანა უფასოა",
    weight: "წონა",
    tbilisi_and_regions: "თბილისი / რეგიონები",
    highland: "მაღალმთიანი",
    region: "რეგიონი",
    admin_bracket_delivery_region_gel: "მიტანა რეგიონი",
    home_delivery_only_notice: "ამ ქვეყანიდან ამანათი მხოლოდ თქვენს მისამართზე მიდის — ოფისზე გატანა არ ხდება",
    see_delivery_prices: "იხილე ტარიფი",
    price_per_kg: "ფასი",
    other_cities_use_tbilisi_rate:
      "დანარჩენ ქალაქებზე გამოიყენება „თბილისი / რეგიონები“-ს ტარიფი.",
    free_delivery_up_to_10kg:
      "10 კგ-მდე ამანათების მისამართამდე მიტანა უფასოა",
    admin_home_delivery_only: "სახლში მიტანით მხოლოდ",
    admin_home_delivery_hint:
      "თუ ჩართულია, ამ საწყობის ამანათი მომხმარებელს პირდაპირ მისამართზე მიაქვთ (ოფისზე გატანა არ ხდება). ტრანსპორტის ფასი საწყობის ვალუტაშია ({{symbol}}) — გათვლაში ხდება ცოცხალი {{code}}→GEL კონვერსია.",
    admin_delivery_tariff_table: "სახლში მიტანის ტარიფი",
    admin_delivery_tariff_hint:
      "თითოეული რიგი ერთი წონის დიაპაზონია. ტრანსპორტი ერიცხება წონას საწყობის ვალუტაში; მიტანა (₾) დაემატება მოცემული ზონისთვის (თბილისი / მაღალმთიანი).",
    admin_bracket_range: "წონა (კგ)",
    admin_tariff_transport: "ტრანსპორტირება",
    admin_tariff_courier: "საკურიერო",
    admin_tariff_bad_range: "„მდე“ უნდა იყოს „დან“-ზე მეტი",
    admin_tariff_gap: "უნდა დაიწყოს წინა რიგის ბოლოდან",
    admin_tariff_highland_empty: "ცარიელი = თბილისის ფასი",
    admin_tariff_courier_included: "შედის ტრანსპორტირებაში",
    admin_tariff_rows: "რიგი",
    admin_tariff_footer: "ზოლს ირჩევს ერთი მიმღების ერთი რეისის ჯამური წონა; საკურიეროს — ერთ მისამართზე გასატანი ამანათების ჯამური წონა.",
    admin_bracket_transport_short: "ტრანსპორტი",
    admin_bracket_transport_tbilisi: "ტრანსპორტი თბილისი",
    admin_bracket_transport_highland: "ტრანსპორტი მაღალმთიანი",
    admin_bracket_delivery_tbilisi_gel: "მიტანა თბილისი",
    admin_bracket_delivery_highland_gel: "მიტანა მაღალმთიანი",
    admin_no_brackets_yet: "ტარიფი ცარიელია — დაამატე რიგი ქვემოთ",
    admin_add_row: "დაამატე რიგი",
    transport_per_kg: "ტრანსპორტი",
    admin_onway: "OnWay საკურიერო",
    flights: "რეისები",

    home_delivery_notice_greeting: "ძვირფასო მომხმარებელო,",
    home_delivery_notice_p1:
      "თქვენი სურვილებისა და მრავალრიცხოვანი მოთხოვნების გათვალისწინებით, MGL Parcel აუმჯობესებს მომსახურებას, რათა ამანათების მიღება კიდევ უფრო მარტივი და კომფორტული გახდეს.",
    home_delivery_notice_p2:
      "2026 წლის 1 სექტემბრიდან თქვენი ამანათები ოფისის ნაცვლად პირდაპირ თქვენს მიერ მითითებულ მისამართზე იქნება მიწოდებული.",
    home_delivery_notice_p3:
      "გთხოვთ, წინასწარ დაამატოთ თქვენი მისამართი პირად კაბინეტში, რათა ამანათები შეუფერხებლად მიიღოთ.",
    home_delivery_notice_bonus:
      "მომხმარებლების სურვილის გათვალისწინებით, 10 კგ-მდე ამანათების მიწოდება საქართველოს ნებისმიერ ქალაქში უკვე შედის ტრანსპორტირების ტარიფში და დამატებითი საფასური არ დაგეკისრებათ.",
    home_delivery_notice_thanks: "გმადლობთ, რომ ირჩევთ MGL Parcel-ს!",
    // legacy keys (kept for backwards-compat if referenced elsewhere)
    home_delivery_popup_title: "მოკლე ხანში — სახლში მიტანა 🏠",
    home_delivery_popup_intro:
      "მომხმარებელთა თხოვნის საფუძველზე ვცვლით სერვისს — მალე ამანათებს ჩვენს ოფისში მისვლის ნაცვლად პირდაპირ თქვენს მიერ მითითებულ მისამართზე მიგიტანთ.",
    home_delivery_popup_action:
      "ცვლილებისთვის მოსამზადებლად, გთხოვთ, დაამატოთ თქვენი მისამართ(ებ)ი პროფილში ახლავე.",
    add_my_address_now: "მისამართის დამატება",
    remind_later: "შემახსენე მოგვიანებით",
    home_delivery_help:
      "მიუთითეთ ბინის მისამართები სადაც აპირებთ ამანათების მიღებას. სახლში მიტანის სერვისზე გადასვლისას მალე ვისარგებლებთ ამ მისამართებით.",
    home_delivery_hint:
      "სახლში მიტანის სამომავლო სერვისისთვის — მიუთითეთ თქვენი მისამართი",
    no_addresses_yet: "ჯერ არ დაგიმატებიათ მისამართი",
    add_new_address: "ახალი მისამართის დამატება",
    new_address: "ახალი მისამართი",
    city: "ქალაქი",
    address: "მისამართი",
    phone_optional: "ტელეფონი (არასავალდებულო)",
    account_phone: "ანგარიშის ტელეფონი",
    set_as_default: "მთავარად დანიშვნა",
    already_default: "მთავარი",
    default: "მთავარი",
    default_updated: "მთავარი მისამართი შეიცვალა",
    edit: "რედაქტირება",
    save: "შენახვა",
    cancel: "გაუქმება",
    delete: "წაშლა",
    confirm_delete_address: "წავშალო ეს მისამართი?",
    something_went_wrong: "დაფიქსირდა შეცდომა",
    reports: "მოხსენებები",
    transaction_history: "ტრანზაქციები",
    insurance: "დაზღვევა",
    settings: "პარამეტრები",
    support: "მხარდაჭერა",
    messages: "შეტყობინებები",
    terms_agreement: " პირობები და შეთანხმება მომხმარებლის პოლიტიკა",
    save_changes: "ცვლილებების შენახვა",
    change: "შეცვალე",
    changed: "შეიცვალა",
    go_back: "უკან გასვლა",
    new_password: "ახალი პაროლი",
    repeat_new_password: "გაიმეორე ახალი პაროლი",
    new_email: "ახალი ელექტრონული ფოსტა",
    email_changed: "ელ. ფოსტა შეიცვალა",
    new_phone: "ახალი ტელეფონი",
    message: "შეტყობინება",
    see_more: "მეტის ნახვა",
    my_messages: "ჩემი შეტყობინებები",
    received_messages: "მიღებული შეტყობინება",
    create_new_messages: "ახალი შეტყობინება",
    type_word_here: "ჩაწერეთ სიტყვა...",
    message_details: "შეტყობინების დეტალები",
    subject: "საგანი",
    assistance: "კონსულტაცია",
    transaction_history: "ტრანზაქციების ისტორია",
    date: "თარიღი",
    amount: "თანხა",
    status: "სტატუსი",
    bank: "ბანკი",
    all_fights: "ყველა რეისი",
    land: "სახმელეთო",
    air: "საჰაერო",
    sea: "საზღვაო",
    select_country: "აირჩიე ქვეყანა",
    status: "სტატუსი",
    flight_number: "რეისის ნომერი",
    estimated_arrival_date: "ჩამოსვლის სავარაუდო დრო",
    arrival_date: "ჩამოსვლის თარიღი",
    address: "მისამართი",
    town_city: "ქალაქი",
    state_province: "შტატი / პროვინცია",
    country: "ქვეყანა",
    post_code: "საფოსტო კოდი (ZIP)",
    tracking_number: "თრექინგ ნომერი",
    received: "მიღებული",
    sent: "გამოგზავნილი",
    arrived: "ჩამოსული",
    takeout: "გატანილი",
    weight: "წონა",
    price: "ფასი",
    pay: "გადახდა",
    paid: "გადახდილია",
    details: "დეტალები",
    declare: "დეკლარირება",
    shipment: "რეისი",
    declaration_details: "დეკლარაციის დეტალები",
    deliver_address: "ტრანსპორტირების მისამართი",
    security: "დაზღვევა",
    description: "ნივთის აღწერა",
    website: "ვებ გვერდი",
    currency: "ვალუტა",
    upload_invoice: "ინვოისის ატვირთვა",
    addon_security: "დაზღვევა",
    save: "შენახვა",
    invoice_details: "ინვოისისი დეტალები",
    user_information: "მომხარებლის ინფორმაცია",
    transportation_details: "ტრანსპორტირების დეტალები",
    transportation_price: "ტრანსპორტირების ღირებულება",
    insurance_price: "დაზღვევის ღირებულება",
    total_value: "სრული ღირებულება",
    bank_information: "ბანკის ინფორმაცია",
    account: "ექაუნთი",
    type_amount_here: "მიუთითეთ თანხა",
    choose_method: "გთხოვთ აირჩიეთ სასურველ ჩარიცხვის მეთოდი",
    payment: "ჩარიცხვა",
    amount: "თანხა",
    top_up_my_ballance: "ჩემი ბალანსის შევსება",
    view_bonus_points: "ბონუს ქულების ნახვა",
    action: "მოქმედება",
    charging_amount_from_ballance: "ბალანსიდან თანხის გასვლა",
    kg: "კგ",
    g: "გ",
    pay_with_points: "ქულებით გადახდა",
    warehouse: "საწყობი",
    trustee: "მინდობილი პირი",
    office: "ოფისი",
    trcaution: `მინდობილ პირს შეუძლია ამანათის მიღება ისევე როგორც საკურირო მისამართზე , ასევე მითითებულ ოფისში`,
    transportation: "ტრანსპორტირება",
    about_us_banner_text: `გამოცადეთ სიმარტივე MGL PARCEL-თან ერთად. ათწლეულზე მეტია, ჩვენ გთავაზობთ სანდო, მეგობრულ და უსაფრთხო ტრანსპორტირებას. ამანათები ჩინეთიდან, აშშ-იდან და საბერძნეთიდან.`,
    about_us_banner_quote: "ჩვენთან ამანათებიც მარტივია.",
    learn_more_about_us: "გაიგეთ მეტი ჩვენს შესახებ",
    ten_year_eperiance: "11 წლიანი გამოცდილება",
    useful_information: "სასარგებლო ინფორმაცია",
    customs_regulations: "საბაჟო წესები",
    client: "კლიენტი",
    street: "ქუჩა",
    terms_and_conditions: "წესები და პირობები",
    minimum_package_weight: "პაკეტის მინიმალური წონა",
    track_parcels: "თვალყური ადევნეთ თქვენს ამანათებს",
    track_parcels_quote: "გაიგეთ ამანათის სტატუსი მისი თრექინგ ნომრის მიხედვით",
    parcel_status: "ამანათის სტატუსი - ",
    data_not_found: "მონაცემები არ მოიძებნა",
    send_new_password: "ახალი პაროლის გამოგზავნა",
    password_sent: "ახალი პაროლი გამოიგზავნა ელ-ფოსტაზე!",
    email_invalid: "ელ-ფოსტა არაა დარეგისტრირებული!",
    do_not_have_insuranced: "თქვენ არ გაქვთ დაზღვეული ამანათი",
    only_georgian: "ტექსტი მიუთითეთ მხოლოდ ქართულად",
    unclear_parcels: "გაურკვეველი ამანათები",
    unlcear_parcels_page_txt:
        "იპოვე შენი ამანთი და გამოაგზავნე შეტყობინება შესაბამის ფოტო მასალასთან ერთად.",
    sent_at: "გამოგზავნის თარიღი",
    terminals_at:
        "ტერმინალური პროცედურების დაწყების თარიღი (საჭიროებს 2-3 სამუშაო დღეს)",
    customs_at:
        "საბაჟო პროცედურების დაწყების თარიღი (საჭიროებს 2-3 სამუშაო დღეს)",
    redistribution_at:
        "ფილიალებში გადანაწილების თარიღი (საჭიროებს 2-3 სამუშაო დღეს)",
    last_updated: "ბოლო განახლება",
    pay_all: "ყველას გადახდა",

    inner_about_us1: `აღმოაჩინეთ MGL Parcel, თქვენი სანდო ლოგისტიკური პარტნიორი დიდი გამოცდილებით და ძლიერი წარმომადგენლობით ევროპაში, საქართველოში და ჩინეთში. ოფისებისა და საწყობების ქსელით, რომლებიც სტრატეგიულად განლაგებულია საკვანძო ადგილებში, ჩვენ გთავაზობთ თქვენი ამანათების უსაფრთხო და ეფექტურ ტრანსპორტირებას.`,
    inner_about_us2: `მომხმარებელზე ორიენტირებული მიდგომით, ჩვენთვის პრიორიტეტია თქვენი კმაყოფილება, სწორედ ამიტომ გთავაზობთ თქვენზე მორგებულ გადაწყვეტილებებს. `,
    inner_about_us3: `ჩვენი გამოცდილი პროფესიონალთა გუნდი ცდილობს უზრუნველყოს განსაკუთრებული მომსახურება და გამოიჩინოს დეტალური ყურადღება ამანათის ტრანსპორტირების პროცესის ყოველ ეტაპზე. ჩვენ გვესმის დროული და უსაფრთხო მიწოდების მნიშვნელობა და ვცდილობთ გადავაჭარბოთ თქვენს მოლოდინს ჩვენი საიმედო და ეკონომიური გადაწყვეტილებებით.`,
    inner_about_us4: `განიცადეთ კომფორტი და სიმშვიდე, რაც მოდის MGL Parcel-თან პარტნიორობით. მოგვანდეთ თქვენი ამანათების ტრანსპორტირება ჩინეთიდან, აშშ-იდან და საბერძნეთიდან.`,

    our_services: "ჩვენი  სერვისები",
    land_transportation: "სახმელეთო გადაზიდვა",
    kg_constraint: "ამანათის მინიმალური წონა 100 გრამი",
    land_serv1: "საბერძნეთი - სახმელეთო გადაზიდვები",
    land_serv2: "",
    land_serv3: "ჩინეთი - 5 აშშ დოლარი 1 კგ",
    air_transportation: "საჰაერო გადაზიდვა",
    air_serv1: "ჩინეთი - 8 - დან  აშშ დოლარი - 1კგ",
    air_serv2: "სპეციალური შეთავაზება + 45 კგ  წონის ტვირთებზე",
    sea_transportation: "საზღვაო გადაზიდვა",
    sea_serv1: "ჩინეთი - 3.5 აშშ დოლარი",

    customs_rules_and_laws: "საბაჟო წესები და კანონები",
    customs_rules_and_laws_text:
        "2022 წლის 14 მაისიდან, შეიცვალა საქართველოს მთავრობის №201 დადგენილება. ბოლო ცვლილების მიხედვით, საქართველოს მთავრობა განბაჟების თანხის პარალელურად, აწესებს საქართველოს საბაჟოს მომსახურების გადასახადს განსაბაჟებელ საქონელზე.",
    customs_rules_and_laws_text1:
        "•  300-დან 3 000 ლარამდე ღირებულების საქონელზე განსაბაჟებელ თანხას დაემატება – 20 ლარი;",
    customs_rules_and_laws_text2:
        "•  3 000-დან 10 000 ლარამდე ღირებულების საქონელზე განსაბაჟებელ თანხას დაემატება – 100 ლარი;",
    customs_rules_and_laws_text3:
        "აღნიშნული თანხის გადახდა მოხდება საქართველოს ხაზინის ანგარიშზე (იხ.ანგარიში: 707017021),  დეკლარაციის დაბეჭდვამდე და განბაჟების საფასურის გადახდამდე.",
    customs_rules_and_laws1: "რა შემთხვევაში ექვემდებარება ამანათი განბაჟებას?",
    customs_rules_and_laws1_text:
        "•  საქართველოს კანონმდებლობით, განბაჟებას ექვემდებარება 300 ლარზე მეტი ღირებულების, 30კგ-ზე მეტი წონის ან ერთგვაროვანი საქონელი.",
    customs_rules_and_laws1_text1:
        "•  საბაჟო გადასახადი შეადგენს პროდუქციის ღირებულების და ტრანსპორტირების ჯამის 18%-ს.",
    customs_rules_and_laws2: "რატომ უნდა დაადეკლარიროთ ნივთი ჩამოსვლამდე?",
    customs_rules_and_laws2_text:
        "•  იმ შემთხვევაში, თუ ამანათი არ იქნება დეკლარირებული მისი ჩამოსვლის მომენტისთვის, იგი დაყოვნდება საბაჟოზე  1 სამუშაო კვირა.",
    customs_rules_and_laws2_text1: `•	იმ შემთხვევაში, თუ აღნიშნული ვადის განმავლობაში, არ დაადეკლარირებთ ამანათს  ამანათი ავტომატურად გადაეცემა სახელმწიფოს შემდგომი განკარგვისთვის. 
    გაითვალისწინეთ, თუ მომხმარებლის სახელზე საზღვარს კვეთს რამდენიმე ამანათი, ხოლო დაუდეკლარირებელია მხოლოდ ნაწილი, საბაჟო დაუდეკლარირებელ ამანათებთან ერთად აჩერებს მომხმარებლის დადეკლარირებულ ამანათებსაც. 
    1 კვირის შემდეგ, კანონის მიხედვით ყველა ამანათი ერთად გადადის სახელმწიფოს მფლობელობაში.`,
    customs_rules_and_laws3: "რა დოკუმენტაცია საჭირო ამანათის განსაბაჟებლად?",
    customs_rules_and_laws3_text:
        "•  იმ შემთხვევაში, თუ ამანათი დაექვემდებარა განბაჟებას, მომხმარებელმა ჩვენს ვებ-გვერდზე უნდა ატვირთოს ინვოისი ან შესყიდვის ორდერი, რომელშიც ფიქსირდება შემდეგი სახის ინფორმაცია:",
    customs_rules_and_laws3_text1: "•  მიმღების სახელი",
    customs_rules_and_laws3_text2: "•  მიმღების გვარი",
    customs_rules_and_laws3_text3: "•  ოთახის ნომერი",
    customs_rules_and_laws3_text4: "•  ამანათის შიგთავსი ",
    customs_rules_and_laws3_text5: "•  ამანათის ჯამური ღირებულება.",
    customs_rules_and_laws3_text6: `გაითვალისწინეთ: (1) შემოსავლების სამსახურის ახალი წესების მიხედვით დეკლარირებაში ამანათის მიმღების მიერ არასწორად მითითებული ღირებულების შემთხვევაში გათვალისწინებულია საჯარიმო სანქციები`,
    customs_rules_and_laws4:
        "საქართველოს კანონმდებლობით აკრძალულია საფოსტო გზავნილით შემდეგი სახის ნივთების გამოგზავნა:",
    customs_rules_and_laws4_text: "•  რეალური ფული, მონეტები ან ბანკნოტები;",
    customs_rules_and_laws4_text1:
        "•  საბანკო და საკრედიტო ბარათები და სხვა ფასიანი ქაღალდები;",
    customs_rules_and_laws4_text2: "•  საკვები პროდუქცია;",
    customs_rules_and_laws4_text3: "•  ფეთქებადი ნივთიერებები;",
    customs_rules_and_laws4_text4: "•  მიწა და ნერგები მიწით;",
    customs_rules_and_laws4_text5: "•  პორნოგრაფიული სახის პროდუქცია;",
    customs_rules_and_laws4_text6: "•  ცოცხალი ცხოველები;",
    customs_rules_and_laws4_text7:
        "•  ნებისმიერი სახის ნარკოტიკი, ნარკოტიკული ნივთიერებების შემცველი პროდუქცია;",
    customs_rules_and_laws4_text8:
        "•  ნარკოტიკული ან ფსიქოტროპული ნივთიერებების შემცველი მცენარეები ან მათი თესლი;",
    customs_rules_and_laws4_text9: "•  ფსიქოტროპული ნივთიერებები;",
    customs_rules_and_laws4_text10: "•  წამლები (10 შეკვრაზე მეტი);",
    customs_rules_and_laws4_text11: "•  მცენარეების თესლები (25 გრამზე მეტი);",
    customs_rules_and_laws5:
        "აკრძალული ნივთების სია ქვეყნების და მიმართულების მიხედვით :",
    customs_rules_and_laws5_text: "",
    customs_rules_and_laws5_text1: `•  ჩინეთი  ავია - იარაღი, სამიზნე, იარაღის ნაწილები და სხვ, მაგნიტი, სანთელი, სანთებელა (მათ შორის ელექტრო სანთებელა), ფხვნილი, დაპრესილი ფხვნილი, კბილის პასტები, თვალის ჩრდილები, დანა, მაკრატელი და მსგავსი ტიპის ბასრი საგნები, სათამაშო იარაღი, ელექტრო სიგარეტი, ფავერ ბანკი, აკუმულატორი, სითხეები, საღებავი, ფლომასტერი, მცენარეები, სამედიცინო დანიშნულების ტვირთები, ელემენტები (დასაშვებია ელემენტის ჩამოტანა მხოლოდ იმ შემთხვევაში, თუ იგი მოყვება ნივთს. მაგალითად - მობილურს) და  კოსმეტიკური საშუალებები როგორიცაა: მანიკური, აცეტონი, კრემები და სხვა. ფეთქებადსაშიში და აალებადი შეფუთვის მქონე პროდუქცია. მათ შორის: სპრეი, პულვერიზატორი, დეზადორი, აეროზოლი და სუნამო.`,
    customs_rules_and_laws5_text2:
        "•  ჩინეთი საზღვაო - მცენარეები,ფეთქებადსაშიში და აალებადი შეფუთვის მქონე პროდუქცია.იარაღი, სამიზნე, იარაღის ნაწილები და სხვ,",

    panel_insurance_text:
        "MGL PARCEL- ი მომხმარებლებს სთავაზობს ამანათების დაზღვევას საქართველოში გამოგზავნამდე.  და ამით უზრუნველყოს ზარალის სრულად ანაზღაურება ამანათის დაკარგვის ან ტრანსპორტირებისას მისი დაზიანების შემთხვევაში.",
    panel_insurance_text1:
        "გამოწერილი ამანათის დაზღვევა შესაძლებელია მისი მიღების შემდეგ ამანათის საქართველოში გამოგზავნამდე. დაზღვევის მონიშვნის შემთხვევაში ტრანსპორტირების ღირებულებას დაემატება  ამანათის ღირებულების 10 %.",

    თურქეთი: "თურქეთი",
    ჩინეთი: "ჩინეთი",

    code_sent: "კოდი გამოიგზავნა ელექტრონულ ფოსტაზე",
    email_registerd_or_error:
        "მითითებული მეილი უკვე რეგისტრირებულია ან დაფიქსირდა სხვა სახის შეცდომა ცადეთ ხელახლა",
    invalid_code_or_error:
        "მითითებული კოდი არასწორია ან დაფიქსირდა სხვა სახის შეცდომა ცადეთ ხელახლა ",
    email_valid_procc:
        "გთხოვთ გაიაროთ ელ-ფოსტის ვალიდაციის პროცესი გაგრძელებამდე",
    required: "აუცილებელი",

    not_started: "არ დაწყებულა",
    sent: "გზაშია",
    arrived: "ჩამოსულია",
    attach_file: "ფაილის მიმაგრება",
    attached_file: "მიმაგრებული ფაილი",

    denied_items: "აკრძალული ნივთები",

    georgian: "ქართულად",

    personal_parcel: "პერსონალური გზავნილი",
    parcel_amount: "ნივთების რაოდენობა",
    trusted_person: "მინდობილი პირი",

    batumi_poti: "ბათუმი / ფოთი",
    working_hours: "სამუშაო საათები",
    tbilisi: "თბილისი",
    monday_friday: "ორშაბათი - პარასკევი:",
    saturday: "შაბათი:",

    repack: "ამანათის გადაფუთვა",
    repacked: "გადაფუთულია",

    calculate: "გამოთვლა",
    vol_calculator: "მოცულობითი წონის კალკულატორი",
    repack_err:
        "ვერ მოხერხდა ამანათის გადაფუთვა რადგან ამანათის ფასი გამოთვლილია რეალური წონით",
    onlineShop: "ონლაინ მაღაზია",

    declarationPrices: "დეკლარაცია",
    instruction: "ინსტრუქციები",
    calculator: "კალკულატორი",
    information: "ინფორმაცია",

    quotePartOne: "ამანათების გამოწერის",
    quotePartTwo: "ყველაზე",
    quotePartThree: "გზა",
    bannerTextOne: "საცალო მიმართულება",
    bannerTextTwo: "კორპორატიული მიმართულება",

    // Warehouse-country chips (FirstSection + BannerSection).
    our_international_warehouses: "საერთაშორისო საწყობები იქ, სადაც შენ ყიდულობ",
    warehouse_modes_china: "საჰაერო, საზღვაო და სახმელეთო",
    warehouse_modes_usa: "საჰაერო გადაზიდვები",
    warehouse_modes_greece: "სახმელეთო გადაზიდვები",
    delivery_zone: "მიწოდების ზონა",
    what_is_highland: "რას ნიშნავს მაღალმთიანი?",
    current_price: "მიმდინარე",
    from_date_label: "დან",

    // Promocode (Settings page + admin display)
    promo_code: "პრომოკოდი",
    promo_one_at_a_time:
      "ერთდროულად მხოლოდ ერთი პრომოკოდი შეიძლება იყოს გააქტიურებული.",
    promo_active: "აქტიური",
    promo_inactive: "ვადა ამოწურულია",
    promo_from: "დან",
    promo_to: "მდე",
    promo_none: "ამჟამად პრომოკოდი გააქტიურებული არ გაქვთ.",
    promo_replace_hint: "ახალი პრომოკოდი (ჩაანაცვლებს არსებულს)",
    promo_enter_hint: "შეიყვანე პრომოკოდი",
    promo_placeholder: "მაგ.: SUMMER25",
    promo_apply: "გააქტიურება",
    promo_remove: "მოშორება",
    promo_applied: "პრომოკოდი გააქტიურდა",
    promo_removed: "პრომოკოდი მოშორდა",
    promo_not_found: "პრომოკოდი ვერ მოიძებნა",
    promo_expired: "პრომოკოდის ვადა ამოწურულია",
    promo_apply_error: "შეცდომა — სცადეთ თავიდან",
    admin_current_promo: "აქტიური პრომოკოდი",
    admin_scheduled_pricing: "დაგეგმილი ტარიფის ცვლილება",
    admin_scheduled_pricing_hint:
      "მითითებული თარიღიდან PriceCalculator იყენებს ცოცხალ ფასს ცხრილის ნაცვლად. მაღალმთიანი ცალკე იბილინგება მომხმარებლის მისამართის მიხედვით.",
    admin_scheduled_from: "ცოცხალდება (თარიღი)",
    admin_price_scheduled_tbilisi: "თბილისი / რეგიონები",
    admin_price_scheduled_highland: "მაღალმთიანი",

    // MGL Parcel (B2C) block.
    mgl_parcel_tag: "B2C მომსახურება",
    mgl_parcel_headline:
      "MGL Parcel — შენი საერთაშორისო შოპინგის მარტივი გზა.",
    mgl_parcel_body_intro:
      "შეუკვეთე სასურველი პროდუქცია ჩინეთის, აშშ-ისა და საბერძნეთის ონლაინ მაღაზიებიდან და გამოიყენე MGL Parcel-ის საერთაშორისო საწყობები შენი ამანათების მისაღებად.",
    mgl_parcel_body_we_handle:
      "ჩვენ ვიზრუნებთ დანარჩენზე — ამანათის მიღებიდან საქართველოში ჩამოტანამდე და შენს მისამართზე ჩაბარებამდე.",
    mgl_parcel_schedule_heading:
      "წინასწარ განსაზღვრული რეისები. პროგნოზირებადი მიწოდება.",
    mgl_parcel_schedule_body:
      "MGL Parcel-ის რეისები დაგეგმილია კონკრეტული გრაფიკით, რათა ონლაინ შოპინგი უფრო მარტივი და პროგნოზირებადი გახდეს.",
    mgl_parcel_10kg_free:
      "10 კგ-მდე ამანათის საქართველოს მასშტაბით მისამართზე მიწოდების საფასური უკვე ჩართულია ტრანსპორტირების ტარიფში.",
    mgl_parcel_10kg_over:
      "თუ ამანათის წონა 10 კგ-ს აღემატება, დამატებით გადაიხდი მხოლოდ 10 კგ-ს ზემოთ არსებული წონის შესაბამის სხვაობას საკურიერო მომსახურების ტარიფის მიხედვით.",
    mgl_parcel_punchline: "ერთი სერვისი. სამი ქვეყანა. მთელი საქართველო.",
    mgl_parcel_punchline_body:
      "MGL Parcel აერთიანებს საერთაშორისო საწყობებს, სხვადასხვა სატრანსპორტო მიმართულებას, წინასწარ განსაზღვრულ რეისებს და შენს მისამართამდე მიწოდებას ერთ მარტივ სისტემაში.",
    mgl_parcel_cta:
      "შეუკვეთე მსოფლიოს ნებისმიერ ონლაინ მაღაზიაში. მიიღე საქართველოში!",

    // MGL Group (B2B) block.
    mgl_group_tag: "B2B ლოგისტიკური სერვისი",
    mgl_group_headline:
      "MGL Group — ბულგარულ-ქართული საერთაშორისო ლოგისტიკური პარტნიორი ბიზნესისთვის.",
    mgl_group_body_p1:
      "საერთაშორისო ვაჭრობა მომწოდებლების, საწყობების, პორტების, სატრანსპორტო მარშრუტების, საბაჟო პროცესებისა და საბოლოო ბაზრების ერთმანეთთან დაკავშირებული სისტემაა.",
    mgl_group_body_p2:
      "MGL Group ამ სისტემას ერთიან ლოგისტიკურ ჯაჭვად ქმნის.",
    mgl_group_body_p3:
      "ჩვენ ვაერთიანებთ საერთაშორისო გადაზიდვებს, საწყობებს, ტვირთების კონსოლიდაციას, საბაჟო მომსახურებას, საპორტო ოპერაციებსა და დისტრიბუციას, რათა ბიზნესმა მიიღოს არა უბრალოდ ტრანსპორტირება, არამედ წინასწარ დაგეგმილი და კონტროლირებადი ლოგისტიკური გადაწყვეტა.",
    mgl_group_network_heading:
      "ლოგისტიკური ქსელი: აზია — ევროპა — კავკასია — ცენტრალური აზია",
    mgl_group_network_body:
      "ინფრასტრუქტურა მოიცავს სტრატეგიულ ლოგისტიკურ მიმართულებებსა და საწყობებს, მათ შორის ჩინეთსა და ევროპაში. საქართველოს გავლით ვქმნით ეფექტურ კავშირებს რეგიონულ ბაზრებთან.",
    mgl_group_reach_heading:
      "ბიზნესები, რომლებსაც ვემსახურებით:",
    mgl_group_reach_body:
      "საქართველო, სომხეთი, აზერბაიჯანი, ყაზახეთი, უზბეკეთი, ცენტრალური აზია, ევროპა.",
    mgl_group_poti_heading: "ფოთის პორტი",
    mgl_group_poti_body:
      "საზღვაო ტვირთების მიღებიდან საპორტო ოპერაციებით, საბაჟო პროცედურებითა და შემდგომი ტრანსპორტირებით — ჩვენ ვმართავთ ტვირთის მოძრაობის ერთმანეთთან დაკავშირებულ ეტაპებს. პორტიდან საქართველოს ნებისმიერ წერტილამდე და შემდგომ რეგიონულ ბაზრებამდე ხმელეთით და რკინიგზით.",
    mgl_group_modes_heading:
      "საზღვაო · სახმელეთო · საჰაერო · სარკინიგზო · მულტიმოდალური",
    mgl_group_modes_body:
      "ტვირთის ტიპის, მოცულობის, ვადის, დანიშნულებისა და კომერციული მიზნის მიხედვით ვქმნით შესაბამის სატრანსპორტო მოდელს და ვარჩევთ იმ მარშრუტს, რომელიც თქვენი ბიზნესისთვის ოპტიმალურია.",
    mgl_group_punchline:
      "MGL Group — ერთი პარტნიორი მთელი ლოგისტიკური ჯაჭვისთვის.",
    yearsWithYou: "წელი თქვენთან",
    flight: "რეისი",
    volume: "მოცულობითი",
    workingDay: "სამუშაო დღე",
    calculatorsTitle: "მოცულობითი წონის განმარტება",
    calculatorsTextOne: `მოცულობითი წონა არის სპეციალური საზომი ერთეული, რომელიც გამოიყენება 
  კონკრეტული ნივთის სიმკვრივის დასადგენად.ამ საზომს მნიშვნელობა აქვს საერთაშორისო ავია 
  გადაზიდვების განხორციელების დროს. მოცულობითი წონის გამოთვლის ფორმულაა : სიგრძე 
  ( სმ) x სიგანე ( სმ) x სიმაღლე( სმ) /6000 = მოცულობითი წონა ( კგ) .`,
    instructionsTitle: "როგორ გამოვწეროთ?",
    instructionsText: `გთავაზობთ ვიდეო ინსტრუქციებს თუ როგორ გამოვწეროთ 
  ჩინური ონლაინ მაღაზიებიდან და როგორ დავამატოთ ჩვენი გადამზიდის მისამართი,
   სხვადასხვა სავაჭრო პლატორმებზე. ასევე როგორ დავადეკლალიროთ ჩვენს მიერ 
   გამოწერილი ამანათი`,
    seeAll: "ყველას ნახვა",
    instructions: "ინსტრუქციები",
    noInstructions: "ინსტრუქციები ვერ მოიძებნა",
    logout: "გასვლა",
    height: "სიმაღლე",
    width: "სიგანე",
    length: "სიგრძე",
    giftText: "ყოველ 10 კილოგრამზე 1 კილოგრამი საჩუქრად !",
    easy: "მარტივი",
    reliable: "სანდო",
    codes: "კოდები",
    else: "სხვა",
    empty: "ჩანაწერები ვერ მოიძებნა !",
    registration_successful: "რეგისტრაცია წარმატებულია",
    userCabinet: "მომხმარებლის კაბინეტი",
    fast: "სწრაფი",
    china: "ჩინეთი",
    usa: "აშშ",
    greece: "საბერძნეთი",
    turkey: "თურქეთი",
    uploadInvoice: "ინვოისი სავალდებულოა",
    airPrice: "10$ - დან",

    more_than_250: "პაკეტის ღირებულება აღემატება 250 ლარს",
    more_than_30: "პაკეტის წონა აღემატება 30 კილოს",
    more_than_4: "ნივთების რაოდენობა აღემატება 4-ს",

    blogs: "ბლოგები",
    blogs_not_found: "ბლოგები ვერ მოიძებნა",

    real_weight: "რეალური",
    volume_weight: "მოცულობითი",

    promoCode: "პრომო კოდი",
    checkPromoCode: "შეამოწმე პრომო კოდი",
    promoCodeDoNotExits: "მსგავსი პრომოკოდი არ არსებობს",
    rateUs: "შეგვაფასეთ",
    leaveReview: "დატოვეთ შეფასება",
    incident_lost: "ამანათი დაიკარგა",
    incident_damaged: "ამანათი დაზიანდა",
    incident_no_transport: "ტრანსპორტირების საფასური არ გეკისრებათ.",
    incident_refunded_balance: "გადახდილი {{amount}} ₾ დაგიბრუნდათ ბალანსზე.",
    incident_refunded_points: "გადახდილი {{amount}} ქულა დაგიბრუნდათ.",
    incident_compensated: "ნივთის ღირებულება — {{amount}} ₾ — ჩაგერიცხათ ბალანსზე.",
    rate_intro: "ერთი წუთი — თქვენი შეფასება გვეხმარება უკეთესები გავხდეთ.",
    rate_choose_score: "აირჩიეთ ვარსკვლავები",
    rate_comment_optional: "კომენტარი (არასავალდებულო)",
    rate_send: "გაგზავნა",
    rate_score_1: "ცუდი",
    rate_score_2: "სუსტი",
    rate_score_3: "ნორმალური",
    rate_score_4: "კარგი",
    rate_score_5: "შესანიშნავი",
    rate_thank_you: "მადლობა!",
    rate_thank_you_text: "თქვენი შეფასება მიღებულია. მადლობა, რომ სარგებლობთ MGL Parcel-ით.",
    rate_redirect_in: "მთავარ გვერდზე გადახვალთ {{n}} წამში…",
    go_to_main: "მთავარ გვერდზე",
    rate_already_used: "ეს ბმული უკვე გამოყენებულია",
    rate_already_used_text: "ამ ბმულით შეფასება უკვე დატოვეთ — მადლობა! ახალ ბმულს შემდეგი ამანათის ჩაბარებისას მიიღებთ.",
    rate_invalid_link: "ბმული არასწორია ან ვადაგასულია",
    rate_invalid_link_text: "შეფასების ბმული 30 დღე მოქმედებს და მხოლოდ ერთხელ გამოიყენება. ახალს შემდეგი ამანათის ჩაბარებისას მიიღებთ.",

    fine: "ჯარიმა",
    boughtWithPoints: "გადახდილია ბონუს ქულებით",
    "Volumetric weight from 80 cm": "მოცულობითი წონა 80 სმ დან",
    "Volumetric weight from 50 cm": "მოცულობითი წონა 50 სმ დან",
    border_declar_needs_declaration: "წითელი",
    border_declar_declared: "მწვანე",
    border_declar_in_customs: "ყვითელი",
    border_declar_not_needed: "წითელი",

    // Admin panel keys
    admin_users: "მომხმარებლები",
    admin_admins: "ადმინისტრატორები",
    admin_countries: "ქვეყნები",
    admin_abroad_warehouse: "უცხოეთის საწყობი",
    admin_filials: "ფილიალები",
    admin_flights: "რეისები",
    admin_faq: "ხ.დ.კ",
    admin_archive: "არქივი",
    admin_packages: "ამანათები",
    admin_warehouse_arrived: "საწყობში მისული",
    admin_sent: "გამოგზავნილი",
    admin_arrived: "ჩამოსული",
    admin_delivered: "ჩაბარებული",
    admin_support: "საფორთი",
    admin_messages: "მესიჯები",
    admin_declaration_service: "დეკლარაციის სერვისი",
    admin_exports: "ექსპორტები",
    admin_popup: "პოპაპი",
    admin_blogs: "ბლოგები",
    admin_promo_codes: "პრომო კოდები",
    admin_reviews: "შეფასებები",
    admin_welcome_back: "მოგესალმებით",
    admin_please_login: "გთხოვთ შეხვიდეთ სისტემაში",
    admin_email_placeholder: "ელ-ფოსტა",
    admin_password_placeholder: "პაროლი",
    admin_login_button: "შესვლა",
    admin_login_error: "პაროლი ან ელ-ფოსტა არასწორია!",
    admin_user_search_placeholder: "მომხმარებლის ID, ელ-ფოსტა, ტელეფონი",
    admin_physical: "ფიზიკური",
    admin_legal: "იურიდიული",
    admin_online_shop: "ონლაინ მაღაზია",
    admin_all: "ყველა",
    admin_edit_user_info: "მომხმარებლის ინფორმაციის რედაქტირება",
    admin_save: "შენახვა",
    admin_login_as: "შესვლა როგორც",
    admin_first_name: "სახელი",
    admin_last_name: "გვარი",
    admin_email: "ელ-ფოსტა",
    admin_personal_number: "პირადი ნომერი",
    admin_first_name_latin: "სახელი (ლათინური)",
    admin_last_name_latin: "გვარი (ლათინური)",
    admin_phone: "ტელეფონი",
    admin_identification_code: "საიდენთიფიკაციო კოდი",
    admin_balance: "ბალანსი",
    admin_discount_percent: "ფასდაკლების პროცენტი",
    admin_type: "ტიპი",
    admin_physical_person: "ფიზიკური პირი",
    admin_legal_person: "იურიდიული პირი",
    admin_name_surname: "სახელი და გვარი",
    admin_room_number: "ოთახის ნომერი",
    admin_edit: "რედაქტირება",
    admin_success: "მოქმედება წარმატებით შესრულდა!",
    admin_error: "დაფიქსირდა შეცდომა, სცადეთ ხელახლა!",
    admin_data_updated: "მონაცემი წარმატებით განახლდა!",
    admin_deleted_success: "წარმატებით წაიშალა!",
    admin_added_success: "წარმატებით დაემატა!",
    admin_saved_success: "წარმატებით შეინახა!",
    admin_sent_success: "წარმატებით გაიგზავნა!",
    admin_packages_sent: "ამანათები წარმატებით გაიგზავნა!",
    admin_packages_received: "ამანათები წარმატებით მიიღეს!",
    admin_packages_delivered: "ამანათები წარმატებით ჩაბარდა!",
    admin_package_deleted: "ამანათი წარმატებით წაიშალა!",
    admin_returned_to_prev: "ამანათები დაბრუნდა წინა განყოფილებაში!",
    admin_action_success: "მოქმედება წარმატებით შესრულდა!",
    admin_add_new_faq: "ახალი კითხვის დამატება",
    admin_categories: "კატეგორიები",
    admin_payments: "გადახდები",
    admin_general: "ზოგადი",
    admin_customs_rules: "საბაჟო წესები",
    admin_video_instruction: "ვიდეო ინსტრუქცია",
    admin_branch_name: "ფილიალის სახელი",
    admin_answer: "პასუხი",
    admin_edit_faq: "კითხვის რედაქტირება",
    admin_inbox: "შემოსული",
    admin_sent_messages: "გაგზავნილი",
    admin_send_global_message: "გლობალური შეტყობინების გაგზავნა",
    admin_message: "შეტყობინება",
    admin_send: "გაგზავნა",
    admin_send_personal_message: "პირადი შეტყობინების გაგზავნა",
    admin_number: "ნომერი",
    admin_person: "პირი",
    admin_subject: "თემა",
    admin_date: "თარიღი",
    admin_attached_file: "მიმაგრებული ფაილი",
    admin_attach_file: "ფაილის მიმაგრება",
    admin_add_new_code: "ახალი კოდის დამატება",
    admin_office: "ოფისი",
    admin_code: "კოდი",
    admin_discount_percent_example: "ფასდაკლება % (მაგ.: 20)",
    admin_date_from: "თარიღიდან",
    admin_date_to: "თარიღამდე",
    admin_edit_code: "კოდის რედაქტირება",
    admin_name_or_discount_empty: "სახელი ან ფასდაკლების პროცენტი ცარიელია",
    admin_messages_label: "შეტყობინებები",
    admin_add_new_filial: "ახალი ფილიალის დამატება",
    admin_edit_filial: "ფილიალის რედაქტირება",
    admin_filial_name: "ფილიალის სახელი",
    admin_address: "მისამართი",
    admin_city: "ქალაქი",
    admin_working_hours: "სამუშაო საათები",
    admin_map_url: "რუქის URL",
    admin_transactions: "ტრანზაქციები",
    admin_logs: "ლოგები",
    admin_package_history: "პაკეტების ისტორია",
    admin_user: "მომხმარებელი",
    admin_package_number: "ამანათის ნომერი",
    admin_action: "მოქმედება",
    admin_description: "აღწერა",
    admin_user_room_id: "მომხმარებლის ოთახის ID",
    admin_transaction_code: "ტრანზაქციის კოდი",
    admin_amount: "თანხა",
    admin_status: "სტატუსი",
    admin_completed_success: "წარმატებით დასრულდა",
    admin_completed_failure: "წარუმატებლად დასრულდა",
    admin_admin: "ადმინი",
    admin_add_new_admin: "ახალი ადმინის დამატება",
    admin_admin_role: "ადმინის როლი",
    admin_super_admin: "სუპერ ადმინი",
    admin_turkey_operator: "თურქეთის ოპერატორი",
    admin_sea_china_operator: "საზღვაო - ჩინეთის ოპერატორი",
    admin_air_china_operator: "საავიაციო - ჩინეთის ოპერატორი",
    admin_usa_operator: "აშშ-ის ოპერატორი",
    admin_greece_operator: "საბერძნეთის ოპერატორი",
    admin_ops_operator: "ოპერატორი (ამანათები + OnWay)",
    admin_spacecargo_viewer: "SpaceCargo — მხოლოდ ნახვა",
    admin_edit_admin_profile: "ადმინის პროფილის რედაქტირება",
    admin_change: "შეცვლა",
    admin_rating: "შეფასება",
    admin_add_new_popup: "ახალი პოპაპის დამატება",
    admin_text_georgian: "ტექსტი ქართულად",
    admin_text_english: "ტექსტი ინგლისურად",
    admin_text_russian: "ტექსტი რუსულად",
    admin_add_new_country: "ახალი ქვეყნის დამატება",
    admin_upload_photo: "ფოტოს ატვირთვა",
    admin_country: "ქვეყანა",
    admin_edit_country: "ქვეყნის რედაქტირება",
    admin_abroad_office: "უცხოეთის ოფისი",
    admin_flights_label: "რეისები",
    admin_in_warehouse: "საწყობში",
    admin_sent_status: "გამოგზავნილი",
    admin_arrived_status: "ჩამოსული",
    admin_delivered_status: "ჩაბარებული",
    admin_georgia_offices: "საქართველოს ოფისები",
    admin_transportation: "ტრანსპორტირება",
    admin_flights_export_csv: "რეისების CSV ექსპორტი",
    admin_users_ledger: "მომხმარებლები — BOG შევსებები",
    admin_users_ledger_hint: "ყველა მომხმარებელი და BOG-ით შევსებული ჯამური თანხა (რაოდენობა და ბოლო შევსების თარიღიც).",
    admin_users_ledger_user: "მომხმარებელი",
    admin_users_ledger_dates_note: "თარიღები ვრცელდება შევსებებზე",
    admin_topups_title: "ბალანსის შევსებები",
    admin_topups_hint: "აირჩიე თვე ან პერიოდი. „მომხმარებლები“ — მხოლოდ ისინი, ვინც ამ პერიოდში შეავსო ბალანსი, თავისი ჯამით (პერიოდის გარეშე — ყველა მომხმარებელი). „ჩარიცხვები“ — თითოეული შევსება ცალკე ხაზად, ბოლოს ჯამი.",
    admin_topups_month: "თვე",
    admin_topups_users_period: "მომხმარებლები, ვინც შეავსო",
    admin_topups_users_all: "ყველა მომხმარებელი",
    admin_topups_transactions: "ჩარიცხვები",
    admin_date_kind: "თარიღის ტიპი",
    admin_date_received: "საზღვარგარეთ ოფისში მიღება",
    admin_date_sent: "გამოგზავნა",
    admin_date_arrived: "საქართველოში ჩამოსვლა",
    admin_date_shown: "კლიენტთან გამოჩენა",
    admin_date_delivered: "კლიენტმა ჩაიბარა",
    admin_date_paid: "გადახდა",
    admin_date_pick_range: "მიუთითეთ თარიღი (დან / მდე)",
    admin_matches: "ემთხვევა",
    admin_declarant_export_csv: "დეკლარანტის CSV ექსპორტი",
    admin_add_new_flight: "ახალი რეისის დამატება",
    admin_search_keyword: "საძიებო სიტყვა",
    admin_flight_type: "ტიპი",
    admin_clear: "გასუფთავება",
    admin_arrival_approx_time: "სავარაუდო ჩამოსვლის დრო",
    admin_flight_number: "რეისის ნომერი",
    admin_approx_arrival: "სავარაუდო ჩამოსვლა",
    admin_arrival_time: "ჩამოსვლის დრო",
    admin_turkey: "თურქეთი",
    admin_china: "ჩინეთი",
    admin_cargo: "სატვირთო",
    admin_airplane: "ავია",
    admin_ship: "გემი",
    admin_not_started: "არ დაწყებულა",
    admin_on_the_way: "გზაშია",
    admin_has_arrived: "ჩამოვიდა",
    admin_edit_flight: "რეისის რედაქტირება",
    admin_start_date: "დაწყების თარიღი",
    admin_end_date: "დასრულების თარიღი",
    admin_other: "სხვა",
    admin_main_info: "მთავარი ინფორმაცია",
    admin_add_new_blog: "ახალი ბლოგის დამატება",
    admin_main_photo: "მთავარი ფოტო",
    admin_inner_photos: "შიდა ფოტოები",
    admin_title: "სათაური",
    admin_short_description: "მოკლე აღწერა",
    admin_long_description: "სრული აღწერა",
    admin_close: "დახურვა",
    admin_edit_info: "ინფორმაციის რედაქტირება",
    admin_edit_blog: "ბლოგის რედაქტირება",
    admin_add_new_warehouse: "ახალი საწყობის დამატება",
    admin_edit_warehouse: "საწყობის რედაქტირება",
    admin_warehouse: "საწყობი",
    admin_global_no_scope: "— გლობალური (ყველა საწყობი) —",
    admin_price: "ფასი",
    admin_phone_label: "ტელეფონი",
    admin_zip_code: "საფოსტო კოდი",
    admin_state: "შტატი",
    admin_address1: "მისამართი 1",
    admin_address2: "მისამართი 2",
    admin_country_label: "ქვეყანა",
    admin_weight_price: "წონის ფასი",
    admin_office_type: "ოფისის ტიპი",
    admin_room_number_label: "ოთახის ნომერი",
    admin_flight_label: "რეისი",
    admin_amount_label: "თანხა",
    admin_no_data_found: "მონაცემები არ მოიძებნა",
    admin_to_pay: "გადასახდელია",
    admin_paid: "გადახდილია",
    admin_delete: "წაშლა",
    admin_choose: "არჩევა",
    admin_search: "ძებნა",
    admin_select_all: "ყველას მონიშვნა",
    admin_insured_packages: "დაზღვეული ამანათები",
    admin_repacked_packages: "გადაფუთული ამანათები",
    admin_send_selected: "მონიშნულის გამოგზავნა",
    admin_send_by_flight: "რეისით გამოგზავნა",
    admin_receive_selected: "მონიშნულის მიღება",
    admin_deliver_selected: "მონიშნულის ჩაბარება",
    admin_show_to_user: "მომხმარებელთან ჩამოსულად მონიშვნა",
    admin_export_csv: "CSV ექსპორტი",
    admin_flight_number_for_excel: "რეისის ნომერი ექსელის ექსპორტისთვის",
    admin_general_flight_number: "საერთო რეისის ნომერი (სურვილისამებრ)",
    admin_warehouse_packages: "საწყობის ამანათები",
    admin_sent_packages: "გამოგზავნილი ამანათები",
    admin_arrived_packages: "ჩამოსული ამანათები",
    admin_receivable_packages: "მისაღები ამანათები",
    admin_user_info: "მომხმარებლის ინფორმაცია",
    admin_shipment_info: "გადაზიდვის ინფორმაცია",
    admin_tracking_number: "ტრეკინგის ნომერი",
    admin_total_amount: "ჯამური თანხა",
    admin_total_weight: "ჯამური წონა",
    admin_transport_type: "ტრანსპორტირება",
    admin_flight_info: "რეისი",
    admin_trusted_person: "მინდობილი პირი",
    admin_comment: "კომენტარი",
    admin_repack_needed: "გადაფუთვა საჭიროა",
    admin_item_price: "ნივთის ფასი",
    admin_transport_price: "ტრანსპორტის ფასი",
    admin_insurance: "დაზღვევა",
    admin_invoice: "ინვოისი",
    admin_no: "არა",
    admin_yes: "კი",
    admin_details: "დეტალები",
    admin_remove: "ამოღება",
    admin_back: "უკან",
    admin_send_out: "გაგზავნა",
    admin_receive: "მიღება",
    admin_deliver: "ჩაბარება",
    admin_memorize: "ცვლილებების შენახვა",
    admin_delete_declaration: "დეკლარაციის წაშლა",
    admin_cancel_courier: "კურიერის გაუქმება",
    admin_remove_repack: "გადაფუთვის გაუქმება",
    admin_reset_fine: "ჯარიმის გასუფთავება",
    admin_assign_user: "მომხმარებლის მინიჭება",
    admin_weight: "წონა",
    admin_length: "სიგრძე",
    admin_width: "სიგანე",
    admin_height: "სიმაღლე",
    admin_flight_number_input: "რეისის ნომერი",
    admin_declar_not_needed: "არ სჭირდება",
    admin_declar_red: "წითელი",
    admin_declar_green: "მწვანე",
    admin_declar_yellow: "ყვითელი",
    admin_inner_courier_amount: "შიდა კურიერის თანხა",
    admin_language: "ენა",
    admin_georgian: "ქართული",
    admin_english: "ინგლისური",
    admin_discount_percent_label: "ფასდაკლების პროცენტი",
    admin_inner_courier_price: "შიდა კურიერის ფასი",
    admin_error_try_again: "დაფიქსირდა შეცდომა, სცადეთ ხელახლა!",
    admin_added_successfully: "წარმატებით დაემატა!",
    admin_deleted_successfully: "წარმატებით წაიშალა!",
    admin_data_updated_success: "მონაცემი წარმატებით განახლდა!",
    admin_data_updated_successfully: "მონაცემი წარმატებით განახლდა!",
    admin_data_added_success: "წარმატებით დაემატა!",
    admin_data_deleted_success: "წარმატებით წაიშალა!",
    admin_blog_deleted_success: "ბლოგი წარმატებით წაიშალა!",
    admin_blog_added_success: "ბლოგი წარმატებით დაემატა!",
    admin_blog_updated_success: "ბლოგი წარმატებით განახლდა!",
    admin_updated_success: "წარმატებით განახლდა!",
    admin_office_deleted_success: "ოფისი წარმატებით წაიშალა!",
    admin_office_added_success: "ოფისი წარმატებით დაემატა!",
    admin_country_deleted_success: "ქვეყანა წარმატებით წაიშალა!",
    admin_country_added_success: "ქვეყანა წარმატებით დაემატა!",
    admin_data_added_successfully: "მონაცემი წარმატებით დაემატა!",
    admin_search_placeholder: "მომხმარებლის ID, ელ-ფოსტა, ტელეფონი",
    admin_region: "რეგიონი",
    admin_min_weight: "მინიმალური წონა",
    admin_currency: "ვალუტა",
    admin_delivery_price: "მიწოდების ფასი",
    admin_repack_price: "გადაფუთვის ფასი",
    admin_volumetric_min_side: "მოცულობითი წონა — უდიდესი გვერდი, სმ-დან (0 = ნებისმიერი)",
    admin_prices: "ფასები",
    admin_arrival_approx_date: "სავარაუდო ჩამოსვლის თარიღი",
    admin_redistribution_start_date: "ფილიალებში გადანაწილების დაწყების თარიღი",
    admin_arrival_date: "ჩამოსვლის თარიღი",
    admin_sent_date: "გაგზავნის თარიღი",
    admin_terminal_procedures_start_date: "ტერმინალის პროცედურების დაწყების თარიღი",
    admin_customs_procedures_start_date: "საბაჟო პროცედურების დაწყების თარიღი",
    admin_created_date: "შექმნის თარიღი",
    admin_fine: "ჯარიმა",
    admin_total_price: "ჯამური თანხა",
    admin_kg: "კგ",
    admin_insured: "დაზღვეული",
    admin_not_insured: "დაუზღვეველი",
    admin_bag: "ჩანთა",
    admin_volume_weight: "მოცულობითი წონა",
    admin_flight: "რეისი",
    admin_nullify_fine: "ჯარიმის გასუფთავება",
    admin_border_declaration_status: "სასაზღვრო დეკლარაციის სტატუსი",
    admin_no_declaration_needed: "დეკლარაცია არ სჭირდება",
    admin_red: "წითელი",
    admin_green: "მწვანე",
    admin_yellow: "ყვითელი",
    admin_creation_date: "შექმნის თარიღი",
    admin_unpaid: "გადაუხდელია",
    admin_courier_cancel: "კურიერის გაუქმება",
    admin_repack_remove: "გადაფუთვის გაუქმება",
    admin_fine_reset: "ჯარიმის გასუფთავება",
    admin_declaration_not_needed: "არ სჭირდება",
    admin_package_delivered_success: "ამანათი წარმატებით ჩაბარდა!",
    admin_package_fee_or_declaration_fee_unpaid: "ამანათის საფასური გადაუხდელია ან დეკლარაცია მოლოდინშია!",
    admin_package_fee_unpaid: "ამანათის საფასური გადაუხდელია!",
    admin_unpaid_package_or_other_error: "გადაუხდელი ამანათი ან სხვა შეცდომა აღმოჩნდა!",
    admin_package_deleted_success: "ამანათი წარმატებით წაიშალა!",
    admin_shown_to_user_success: "წარმატებით ნაჩვენები მომხმარებელს!",
    admin_packages_returned_to_previous_section: "ამანათები დაბრუნდა წინა განყოფილებაში!",
    admin_changed_success: "წარმატებით შეიცვალა!",
    admin_georgia_branches: "საქართველოს ფილიალები",
    // დეკლარაციისას მისათითებელი მიტანის მისამართი
    delivery_address: "მიტანის მისამართი",
    add_new_address: "ახალი მისამართი",
    choose_address: "აირჩიეთ მიტანის მისამართი",
    no_address_yet: "მისამართი არ გაქვთ დამატებული — დაამატეთ გასაგრძელებლად.",
    city: "ქალაქი",
    address: "მისამართი",
    phone: "ტელეფონი",
    optional: "არასავალდებულო",
    fill_all_fields: "შეავსეთ ქალაქი და მისამართი",
    send_code: "კოდის გაგზავნა",
    sms_code: "SMS კოდი",
    verify_phone_first: "ჯერ დაადასტურეთ ტელეფონის ნომერი",
    verify_email_first: "ჯერ დაადასტურეთ ელფოსტა",
    sms_code_sent: "კოდი გამოიგზავნა SMS-ით",
    email_code: "კოდი წერილიდან",
    confirm_code: "დადასტურება",
    // Price breakdown popup (user panel, admin panel, landing calculator)
    price_breakdown: "ფასის დეტალები",
    why_this_price: "რატომ ღირს ამდენი?",
    how_price_calculated: "როგორ დაითვალა ეს ფასი",
    parcel_details: "ამანათის დეტალები",
    flight_title: "თქვენი ამანათები ამ რეისზე",
    flight_this: "ეს ამანათი",
    flight_total: "სულ რეისზე",
    flight_due: "გადასახდელი ჯამში",
    flight_tier_note: "1 კგ-ის ტარიფი ჯამური წონით შეირჩა — {{total}} კგ ({{tier}} კგ-ის ტარიფი), არა თითო ამანათის წონით.",
    flight_home_note: "თითო ამანათი საკუთარი წონით ფასდება; საკურიერო კი ერთხელ ითვლება, ჯამურ {{total}} კგ-ზე.",
    flight_fee_estimate: "სავარაუდო საკურიერო",
    flight_together: "ამანათები ერთად ჩამოვა და ერთ მიტანაში გამოგზავნება.",
    flight_split_address: "ამანათებს სხვადასხვა მისამართი აქვს — ცალ-ცალკე მიტანა იქნება.",
    whats_going_on: "სად არის ამანათი",
    step_registered: "დარეგისტრირდა",
    step_warehouse: "მიღებულია საწყობში",
    step_sent: "გამოიგზავნა",
    step_terminals: "ტერმინალშია",
    step_customs: "საბაჟოზეა",
    step_arrived: "ჩამოვიდა საქართველოში",
    step_arrived_est: "სავარაუდო ჩამოსვლა",
    step_ready: "მზადაა გასაცემად",
    step_courier: "გადაეცა კურიერს",
    step_delivered: "ჩაბარდა",
    customs_title: "განბაჟება",
    customs_not_needed: "განბაჟება არ სჭირდება",
    customs_must_declare: "საჭიროა განბაჟება",
    customs_declared: "განბაჟებულია",
    customs_in_customs: "საბაჟოზეა დაკავებული",
    declaration_missing: "ამანათი დაუდეკლარირებელია — მიუთითეთ ღირებულება და ნივთები",
    declaration_ok: "დეკლარაცია შევსებულია",
    delivery_title: "მიტანა",
    delivery_by_courier: "კურიერი მოგიტანთ მისამართზე, მიტანამდე დაგიკავშირდებით",
    delivered_by_courier: "ჩაგბარდათ კურიერისგან",
    delivered_to_address: "ჩაბარდა მისამართზე",
    delivered_to_person: "გადაეცა მინდობილ პირს",
    delivered_to_recipient: "ჩაიბარეთ",
    delivery_group_note: "საკურიერო ერთ მისამართზე ერთხელ ითვლება, ყველა ამანათის ჯამური წონით — არა თითო ამანათზე.",
    delivery_fee_free: "უფასო",
    courier_order: "საკურიერო შეკვეთა (OnWay)",
    courier_status: "სტატუსი",
    courier_cancelled: "შეკვეთა გაუქმებულია",
    courier_expected: "სავარაუდო მიტანა",
    courier_cod: "კურიერთან გადასახდელი",
    courier_history: "კურიერის ისტორია",
    courier_grouped_with: "ერთ შეკვეთაშია:",
    payment_title: "გადახდა",
    payment_paid_full: "გადახდილია",
    payment_due: "გადასახდელია",
    paid_via_courier: "გადახდილია კურიერთან",
    payment_cod_locked: "ეს ამანათი კურიერს გადაეცა თანხის ადგილზე აღებით — გადაიხდით მიღებისას, საიტზე გადახდა დროებით შეზღუდულია.",
    todo_title: "რა არის საჭირო",
    todo_address: "მიუთითეთ მიტანის მისამართი",
    todo_declaration: "დაადეკლარირეთ ამანათი",
    todo_payment: "დაფარეთ დავალიანება",
    todo_pay_at_door: "თანხას კურიერს გადაუხდით მიღებისას",
    todo_none: "ყველაფერი რიგზეა — მეტი არაფერია საჭირო",
    billed_weight: "ასაღები წონა",
    billed_on_volume: "მოცულობითი წონით",
    billed_on_real: "რეალური წონით",
    price_per_kg: "1 კგ-ის ფასი",
    volume_formula: "მოცულობითი წონა = სიგრძე × სიგანე × სიმაღლე (მ) × 167",
    volume_not_used_small: "მოცულობითი წონა არ გამოიყენება — ამანათის არცერთი გვერდი არ აღემატება {{cm}} სმ-ს (ყველაზე გრძელი: {{longest}} სმ).",
    volume_not_used_repack: "ამანათი გადაფუთულია ჩვენს ყუთში, ამიტომ ფასი ითვლება რეალურ წონაზე.",
    volume_not_used_nodim: "ამანათის ზომები არ არის გაზომილი, ამიტომ ფასი ითვლება რეალურ წონაზე.",
    volume_used_note: "მოცულობითი წონა რეალურზე მეტია, ამიტომ ფასი მასზე ითვლება.",
    tier_note: "1 კგ-ის ტარიფი ({{tier}} კგ) შეირჩა ამ რეისზე თქვენი ყველა ამანათის ჯამური წონით — {{group}} კგ.",
    tier_note_single: "1 კგ-ის ტარიფი შეირჩა {{tier}} კგ-ის დიაპაზონით.",
    bracket_note: "ტარიფი შეირჩა {{bracket}} კგ-ის დიაპაზონით.",
    scheduled_rate_note: "მოქმედებს ამ საწყობის განახლებული ტარიფი.",
    zone_highland: "მაღალმთიანი ზონა",
    zone_tbilisi: "თბილისი / რეგიონები",
    line_base: "ტრანსპორტირება",
    line_repack_uplift: "გადაფუთვა",
    line_delivery_overage: "საკურიერო მომსახურება",
    line_insurance: "დაზღვევა (10%)",
    line_discount: "ფასდაკლება",
    line_promo: "პრომოკოდი",
    line_inner_price: "შიდა გადაზიდვა",
    line_fine_price: "ჯარიმა",
    total_to_pay: "ჯამი",
    price_locked_note: "ამანათს ფასი დაფიქსირებული აქვს ადმინისტრატორის მიერ.",
    price_stale_note: "გადასახდელი თანხაა {{charged}} ₾. მიმდინარე ტარიფებით იგივე ამანათი დაჯდებოდა {{computed}} ₾.",
    rate_used: "კურსი",
    explain_load_error: "დეტალების ჩატვირთვა ვერ მოხერხდა.",
    // Landing-page shop directory
    shops: "მაღაზიები",
    shops_subtitle: "აირჩიეთ მაღაზია, გამოიწერეთ პროდუქტი და ჩვენ ჩამოგიტანთ",
    all_countries: "ყველა ქვეყანა",
    all_categories: "ყველა კატეგორია",
    no_shops_found: "ამ ფილტრით მაღაზია ვერ მოიძებნა",
    // Admin shop directory
    admin_shops: "მაღაზიები",
    admin_shop_categories: "მაღაზიების კატეგორიები",
    admin_shop_category_delete_note: "კატეგორიის წაშლისას მისი მაღაზიები რჩება, უბრალოდ კატეგორიის გარეშე.",
    admin_link: "ბმული",
    admin_logo: "ლოგო",
    admin_category: "კატეგორია",
    admin_sort: "სორტირება",
    admin_active: "აქტიური",
    admin_name_ge: "დასახელება (ქარ)",
    admin_name_en: "დასახელება (ინგ)",
    admin_fill_required: "შეავსეთ სავალდებულო ველები",
    admin_name: "დასახელება",
    admin_cancel: "გაუქმება",
    admin_add: "დამატება",
    admin_add_new: "ახლის დამატება",
    admin_something_wrong: "დაფიქსირდა შეცდომა",
    cm: "სმ",
    // Courier delivery fee (one per address)
    delivery_fee: "საკურიერო მომსახურება",
    delivered_by_courier_on: "კურიერმა ჩააბარა",
    delivery_fee_past: "წინა მიტანის საკურიერო",
    delivery_fee_note: "ღირებულება ითვლება ერთ მისამართზე გასატან ამანათებზე ჯამურად. ახალი ამანათის დამატებისას შეიცვლება და მხოლოდ სხვაობას გადაიხდით.",
    no_delivery_address_yet: "მიტანის მისამართი არ არის მითითებული",
    total_weight_short: "ჯამური წონა",
    already_paid: "უკვე გადახდილი",
    payment_success: "გადახდა შესრულდა",
    not_enough_funds: "ბალანსზე საკმარისი თანხა არ არის",
    nothing_to_pay_here: "საიტზე გადასახდელი არაფერია — დარჩენილ თანხას (თუ არის) კურიერს გადაუხდით",
    pay_at_courier: "გადაიხდით კურიერთან",
    pay_all_delivery_note: "მათ შორის {{count}} ამანათის ღირებულება — {{packs}} ₾",
};

export default translationGe;